export default "__VITE_ASSET__BRm7V52q__"